import { render, staticRenderFns } from "./Histories.vue?vue&type=template&id=184ee690&scoped=true"
import script from "./Histories.vue?vue&type=script&lang=js"
export * from "./Histories.vue?vue&type=script&lang=js"
import style0 from "./Histories.vue?vue&type=style&index=0&id=184ee690&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184ee690",
  null
  
)

export default component.exports